
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/user-account",
      function () {
        return require("private-next-pages/user/user-account/index.ts");
      }
    ]);
  